import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-963df23c")

_pushScopeId("data-v-963df23c")
const _hoisted_1 = { class: "select-template" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "middle-header-text" }, "使用するテンプレートを選んでください", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "header-dummy" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MiddleHeader = _resolveComponent("MiddleHeader")
  const _component_Thumbnail = _resolveComponent("Thumbnail")
  const _component_HorizontalList = _resolveComponent("HorizontalList")
  const _component_FilterAttribute = _resolveComponent("FilterAttribute")
  const _component_TemplateThumbnail = _resolveComponent("TemplateThumbnail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MiddleHeader, null, {
      default: _withId(() => [
        _hoisted_2,
        _createVNode("button", {
          class: "primary-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toEditCarousel && _ctx.toEditCarousel(...args)))
        }, " カルーセル広告最終画面用素材集 ")
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_HorizontalList, {
      title: "有名マンガ家作品",
      items: _ctx.authorListItems,
      inPageCount: 4,
      emptyItem: _ctx.emptyItem
    }, {
      default: _withId((slotProps) => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.inPageItems, (item) => {
          return (_openBlock(), _createBlock(_component_Thumbnail, {
            class: "thumbnail",
            key: item,
            item: item
          }, null, 8, ["item"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["items", "emptyItem"]),
    _createVNode(_component_FilterAttribute),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array.from(_ctx.attributeTemplateSet), ([key, val]) => {
      return (_openBlock(), _createBlock(_component_HorizontalList, {
        key: key,
        title: key,
        headerLinkText: val[0],
        headerLinkAction: val[1],
        items: val[2],
        inPageCount: 6,
        emptyItem: _ctx.emptyTemplate
      }, {
        default: _withId((slotProps) => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.inPageItems, (item) => {
            return (_openBlock(), _createBlock(_component_TemplateThumbnail, {
              class: "thumbnail",
              key: item.id,
              item: item
            }, null, 8, ["item"]))
          }), 128))
        ]),
        _: 2
      }, 1032, ["title", "headerLinkText", "headerLinkAction", "items", "emptyItem"]))
    }), 128))
  ]))
})